// src/utils/api.js
const BASE = process.env.REACT_APP_API_URL || '/api';

function token() { return localStorage.getItem('pen_token'); }

async function req(method, path, body) {
  const res = await fetch(BASE + path, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...(token() ? { Authorization: 'Bearer ' + token() } : {}),
    },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  if (res.status === 401) { localStorage.removeItem('pen_token'); window.location.href = '/login'; }
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Erro desconhecido');
  return data;
}

export const api = {
  login: (login, senha) => req('POST', '/login', { login, senha }),

  imoveis: () => req('GET', '/imoveis'),
  criarImovel: (b) => req('POST', '/imoveis', b),
  editarImovel: (id, b) => req('PUT', `/imoveis/${id}`, b),
  excluirImovel: (id) => req('DELETE', `/imoveis/${id}`),

  hospedes: (id) => req('GET', `/imoveis/${id}/hospedes`),
  adicionarHospede: (b) => req('POST', '/hospedes', b),
  editarHospede: (id, b) => req('PUT', `/hospedes/${id}`, b),

  pagamentos: (id, mes, ano) => req('GET', `/imoveis/${id}/pagamentos?mes=${mes}&ano=${ano}`),
  marcarPg: (b) => req('POST', '/pagamentos', b),

  resumo: (mes, ano) => req('GET', `/resumo?mes=${mes}&ano=${ano}`),

  custos: (id, mes, ano) => req('GET', `/imoveis/${id}/custos?mes=${mes}&ano=${ano}`),
  criarCusto: (b) => req('POST', '/custos', b),
  editarCusto: (id, b) => req('PUT', `/custos/${id}`, b),
  excluirCusto: (id) => req('DELETE', `/custos/${id}`),
  marcarCustoPago: (id, b) => req('POST', `/custos/${id}/pagamento`, b),

  excluirHospedeDefinitivo: (id) => req('DELETE', `/hospedes/${id}`),

  gastos: (mes, ano) => req('GET', `/gastos?mes=${mes}&ano=${ano}`),
  adicionarGasto: (b) => req('POST', '/gastos', b),
  excluirGasto: (id) => req('DELETE', `/gastos/${id}`),

  caixa: (mes, ano) => req('GET', `/caixa?mes=${mes}&ano=${ano}`),
  adicionarCaixa: (b) => req('POST', '/caixa', b),
  excluirCaixa: (id) => req('DELETE', `/caixa/${id}`),

  reocupacoes: (mes, ano) => req('GET', `/reocupacoes?mes=${mes}&ano=${ano}`),
  adicionarReocupacao: (b) => req('POST', '/reocupacoes', b),
  excluirReocupacao: (id) => req('DELETE', `/reocupacoes/${id}`),
};

export const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];

export function fmtBRL(v) {
  return Number(v||0).toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
}
export function fmtPct(v) {
  return (Number(v||0)*100).toFixed(1)+'%';
}
export function mesAnoLabel(mes, ano) {
  return MESES[(mes||1)-1]+'/'+ano;
}

// Extrai o número inicial de um código de quarto (ex: "9A" -> 9, "12B" -> 12)
export function parseQuartoNum(q) {
  if (!q) return null;
  const m = String(q).match(/(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

// Ordena hóspedes por número de quarto (numérico), depois por letra, depois por nome
export function ordenarPorQuarto(lista) {
  return [...lista].sort((a, b) => {
    const na = parseQuartoNum(a.quarto);
    const nb = parseQuartoNum(b.quarto);
    if (na !== null && nb !== null) {
      if (na !== nb) return na - nb;
      return String(a.quarto||'').localeCompare(String(b.quarto||''));
    }
    if (na !== null) return -1;
    if (nb !== null) return 1;
    return String(a.nome||'').localeCompare(String(b.nome||''));
  });
}
